import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { findCatalogById } from "../../utils/findCatalogById";
import { getCategoryProducts } from "../../store/products/useCases/getCategoryProducts/action";
import {
  saveCategoryFilterType,
  saveCurrentSettings,
  saveProductsPrices,
  saveServerProductsPrices,
} from "../../store/products/repository/actions";
import { getFilters } from "../../store/products/useCases/getFilters/action";
import { selectCurrentLang } from "../../store/language/repository/selectors";
import {
  selectCurrentSettings,
  selectProductsFinish,
  selectProductsLoading,
  selectProductsPrices,
  selectServerProductsPrices,
} from "../../store/products/repository/selectors";
import { selectCatalog } from "../../store/catalog/repository/selectors";
import { selectisLoggedIn } from "../../store/user/repository/selectors";
import { selectPrevPathname } from "../../store/app/repository/selectors";
import { ROUTES } from "../../constants";
import Products from "../../ui-kit/products/products";
import { TelegramButton } from "../../ui-kit/telegramButton/telegramButton";
import { IFilterRequest } from "../../store/products/repository/IFilterRequest";

const ProductListPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const productsLoading = useSelector(selectProductsLoading);
  const productsFinish = useSelector(selectProductsFinish);

  const currentSettings = useSelector(selectCurrentSettings);
  const serverProductPrices = useSelector(selectServerProductsPrices);
  const prevPathname = useSelector(selectPrevPathname);
  const catalog = useSelector(selectCatalog);
  const language = useSelector(selectCurrentLang);
  const isLoggedIn = useSelector(selectisLoggedIn);
  const item = findCatalogById(parseInt(id || "0"), catalog);

  const [isShownTgButton, setShownTgButton] = useState(false);
  const location = useLocation();

  const getParamsFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);

    const filter: IFilterRequest[] = [];
    let priceMin: number | undefined;
    let priceMax: number | undefined;
    let page: number | undefined;

    searchParams.forEach((value, key) => {
      if (key === "priceMin") {
        priceMin = Number(value);
      } else if (key === "priceMax") {
        priceMax = Number(value);
      } else if (key === "page") {
        page = Number(value);
      } else if (!isNaN(Number(key))) {
        filter.push({
          keyId: Number(key),
          values: value.split(";"),
        });
      }
    });

    return {
      id,
      ...(filter.length > 0 && { filter }),
      priceMin,
      priceMax,
      page: page ?? 1,
    };
  };
  const settings = useMemo(() => getParamsFromUrl(), [location.search, id]);

  useEffect(() => {
    dispatch(
      saveCurrentSettings({
        id: settings.id,
        filter: settings.filter,
        priceMin: settings.priceMin,
        priceMax: settings.priceMax,
        page: settings.page,
      }),
    );
  }, [settings]);

  useEffect(() => {
    if (item && item.sortFilterType) {
      dispatch(saveCategoryFilterType(item.sortFilterType));
    }
  }, [id, catalog]);

  useEffect(() => {
    if (prevPathname && prevPathname.includes(ROUTES.SearchResultPage)) {
      dispatch(saveCurrentSettings({ id }));
      dispatch(getCategoryProducts({ id, isSavePrice: true }));
    } else {
      dispatch(
        getCategoryProducts({
          id,
          isSavePrice: true,
          filter: settings?.filter,
          // priceMin: settings?.priceMin,
          // priceMax: settings?.priceMax,
          page: settings?.page || 1,
          ...(serverProductPrices?.minPrice !== settings?.priceMin && {
            priceMin: settings?.priceMin,
          }),
          ...(serverProductPrices?.maxPrice !== settings?.priceMax && {
            priceMax: settings?.priceMax,
          }),
        }),
      );
    }
  }, [id, language, isLoggedIn, settings]);

  useEffect(() => {
    if (!productsLoading && productsFinish) {
      dispatch(getFilters(id, currentSettings?.filter));
    }
  }, [productsLoading, productsFinish]);

  useEffect(() => {
    if (item?.isPartOfTgRadioBot) {
      setShownTgButton(true);
    } else {
      setShownTgButton(false);
    }
    return () => setShownTgButton(false);
  }, [item]);

  return (
    <>
      <Products
        title={item?.name || ""}
        description={item?.description || ""}
      />
      {isShownTgButton && <TelegramButton />}
    </>
  );
};

export default ProductListPage;
